import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { TicketsForm } from "../components";
import { useGlobalState } from "../hooks/useGlobalState";
import { ACTIONS } from "../state";
import { postData } from "../utils/apiCalls";
import { extractAddons, filterProperties } from "../utils/funcs";

export const TForms = () => {
    const { formid } = useParams()
    const { dispatch, cart, promoCode, calculateTotal, price, paymentInfo, processOrder } = useGlobalState()

    useEffect(() => {
        return () => dispatch({ type: ACTIONS.RESET_CART })
    }, [])

    useEffect(() => {
        if (cart.length === 0) return
        dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
        postData(`https://youngstartup.io/api/cwebsite-reg/get_tickets_addons?promo=${promoCode}`, {
            body: {
                tickets: cart
            }
        })
            .then(res => { dispatch({ type: ACTIONS.SET, entity: 'addOns', payload: res }) })
            .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))
    }, [cart.length])

    useEffect(() => {
        if (cart.length === 0) return
        dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
        postData('https://youngstartup.io/api/cwebsite-reg/get_total_price', {
            body: {
                promo_code: promoCode,
                tickets: extractAddons(cart)
            }
        })
            .then(res => dispatch({ type: ACTIONS.SET, entity: 'price', payload: { total: res.total_final, fees: res.fees, discount: res.discount } }))
            .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))
    }, [extractAddons(cart).length, calculateTotal])

    useEffect(() => {
        if (cart.length === 0) return
        dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: true })
        postData('https://youngstartup.io/api/cwebsite-reg/process_order', {
            body: {
                promo_code: promoCode,
                tickets: extractAddons(cart),
                amount_paid: price.total,
                contact_info: filterProperties(paymentInfo, ['card_number', 'month', 'year', 'cvv']),
                cc_info: {
                    card_number: paymentInfo.card_number,
                    exp: `${paymentInfo.year}-${paymentInfo.month}`,
                    cvv: paymentInfo.cvv,
                },
            }
        })
            .then(res => dispatch({ type: ACTIONS.SET, entity: 'orderResponse', payload: res }))
            .finally(() => dispatch({ type: ACTIONS.SET, entity: 'freezeLoader', payload: false }))
    }, [processOrder])

    return (
        <div className='t-forms' style={{ minHeight: '400px' }}>
            <div style={{ height: '50px' }}></div>
            <TicketsForm formid={formid} />
        </div>
    )
}
